/*
  MDRN HyPrEn System Explorer
  - Tabs: FULL SYSTEM (first, default on cold load) / AM / PM / WEEKLY; each selects its first product.
  - Prev/next arrows and ArrowLeft/ArrowRight/Home/End stay within the active protocol.
  - Thumbnails select their product (and therefore its protocol).
  - Idempotent init; re-initialises on Theme Editor section load and follows block selection.
*/
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.__mdrnSeInitialized) return;
    root.__mdrnSeInitialized = true;

    var stageEls = {};
    var panelEls = {};
    var products = [];
    root.querySelectorAll('[data-mdrn-se-product]').forEach(function (el) {
      var id = el.getAttribute('data-id');
      var map = el.closest('.hypren-panel') ? panelEls : stageEls;
      if (!stageEls[id] && !panelEls[id]) {
        products.push({ id: id, protocol: el.getAttribute('data-protocol') });
      }
      map[id] = el;
    });

    var protocolBtns = root.querySelectorAll('[data-mdrn-se-protocol-btn]');
    var thumbs = root.querySelectorAll('[data-mdrn-se-thumb]');
    var prevBtn = root.querySelector('[data-mdrn-se-prev]');
    var nextBtn = root.querySelector('[data-mdrn-se-next]');
    var stepLabel = root.querySelector('[data-mdrn-se-step]');
    var rail = root.querySelector('[data-mdrn-se-rail]');
    var state = { selectedId: root.getAttribute('data-initial-product') || (products[0] && products[0].id) };

    function productById(id) {
      for (var i = 0; i < products.length; i++) if (products[i].id === id) return products[i];
      return null;
    }

    function protocolProducts(protocol) {
      return products.filter(function (p) { return p.protocol === protocol; });
    }

    function show(el, visible, animate) {
      if (!el) return;
      el.hidden = !visible;
      if (visible && animate && !(reduceMotion && reduceMotion.matches)) {
        el.classList.remove('is-entering');
        void el.offsetWidth;
        el.classList.add('is-entering');
      }
    }

    function render(animate) {
      var current = productById(state.selectedId);
      if (!current) return;

      products.forEach(function (p) {
        var visible = p.id === current.id;
        show(stageEls[p.id], visible, animate);
        show(panelEls[p.id], visible, animate);
      });

      root.setAttribute('data-active-protocol', current.protocol);

      protocolBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-protocol') === current.protocol ? 'true' : 'false');
      });

      thumbs.forEach(function (t) {
        var inProtocol = t.getAttribute('data-protocol') === current.protocol;
        t.setAttribute('data-in-protocol', inProtocol ? 'true' : 'false');
        t.setAttribute('aria-current', t.getAttribute('data-id') === current.id ? 'true' : 'false');
      });

      var group = protocolProducts(current.protocol);
      var hideArrows = group.length <= 1;
      if (prevBtn) prevBtn.hidden = hideArrows;
      if (nextBtn) nextBtn.hidden = hideArrows;
      // On narrow screens the rail scrolls sideways: keep the displayed product's thumbnail centred in it.
      // Only the rail scrolls; the page position never changes.
      if (rail && rail.scrollWidth > rail.clientWidth + 1) {
        var activeThumb = rail.querySelector('[data-mdrn-se-thumb][aria-current="true"]');
        if (activeThumb) {
          var left = activeThumb.offsetLeft - (rail.clientWidth - activeThumb.offsetWidth) / 2;
          rail.scrollTo({ left: Math.max(0, left), behavior: animate && !(reduceMotion && reduceMotion.matches) ? 'smooth' : 'auto' });
        }
      }
      if (stepLabel) {
        stepLabel.hidden = hideArrows;
        stepLabel.textContent = hideArrows ? '' : 'Step ' + (group.indexOf(current) + 1) + ' of ' + group.length;
      }
    }

    function selectProduct(id, animate) {
      if (!productById(id) || id === state.selectedId) return;
      state.selectedId = id;
      render(animate !== false);
    }

    function selectProtocol(protocol) {
      var group = protocolProducts(protocol);
      if (group.length) selectProduct(group[0].id);
    }

    function step(dir) {
      var current = productById(state.selectedId);
      if (!current) return;
      var group = protocolProducts(current.protocol);
      if (group.length <= 1) return;
      var idx = group.findIndex(function (p) { return p.id === current.id; });
      selectProduct(group[(idx + dir + group.length) % group.length].id);
    }

    protocolBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectProtocol(btn.getAttribute('data-protocol')); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { selectProduct(t.getAttribute('data-id')); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    root.addEventListener('keydown', function (e) {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) === -1) return;
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      var current = productById(state.selectedId);
      if (!current) return;
      var group = protocolProducts(current.protocol);
      if (group.length <= 1) return;
      e.preventDefault();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'Home') selectProduct(group[0].id);
      if (e.key === 'End') selectProduct(group[group.length - 1].id);
      // Keep focus on the thumbnail of the newly shown product when navigating from the rail.
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-mdrn-se-thumb')) {
        var t = root.querySelector('[data-mdrn-se-thumb][data-id="' + state.selectedId + '"]');
        if (t) t.focus();
      }
    });

    // "Start System": hand off to the page's existing buy box (Kaching subscription / one-time + Add to cart).
    // No add-to-cart logic lives here.
    root.querySelectorAll('[data-mdrn-se-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector('[id^="mdrn-buybox-"] .mcp-buybox') || document.querySelector('[id^="mdrn-buybox-"]');
        if (target) target.scrollIntoView({ behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      });
    });

    root.__mdrnSeSelect = function (id) { selectProduct(id, false); };
    root.__mdrnSeReset = function () { selectProduct(root.getAttribute('data-initial-product'), false); };
    render(false);
  }

  function initAll() {
    document.querySelectorAll('[data-mdrn-system-explorer]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();

  // "See interactive guide" links anywhere on the page: open the explorer on its default Full System view.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-mdrn-se-open-guide]');
    if (!link) return;
    var root = document.querySelector('[data-mdrn-system-explorer]');
    if (!root) return;
    e.preventDefault();
    if (root.__mdrnSeReset) root.__mdrnSeReset();
    root.scrollIntoView({ behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mdrn-system-explorer]');
    if (root) init(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-mdrn-system-explorer]');
    var id = e.target.getAttribute('data-id');
    if (root && id && root.__mdrnSeSelect) root.__mdrnSeSelect(id);
  });
})();
